import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { MORPHEUS_LOGS } from '../../constants/tableTypes'
import { UPDATE_MORPHEUS_LOGS } from '../../constants/actionTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
}

const morpheusLogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MORPHEUS_LOGS:
      return {
        ...state,
        content: action.morpheusLogs,
      }
    case `REPLACE_TABLE_USER_INFO_${MORPHEUS_LOGS}`:
      return reducers.dataTable.replaceTableUsersInfoReducer(
        MORPHEUS_LOGS,
        state,
        action
      )
    default:
      return reducers.dataTable.tableFetchReducer(MORPHEUS_LOGS, state, action)
  }
}

export default combineReducers({
  data: morpheusLogsReducer,
  tableInfo: tableReducer,
  users: (state, action) =>
    reducers.dataTable.mappedUsersReducer(MORPHEUS_LOGS, state, action),
  suggestions: (state, action) =>
    reducers.dataTable.suggestionsFetchReducer(MORPHEUS_LOGS, state, action),
  savedSearches: (state = [], action) =>
    reducers.dataTable.savedSearchesReducer(MORPHEUS_LOGS, state, action),
})

export { initialState, morpheusLogsReducer }
